<template>
  <div>
    <div v-for="(item, index) in list" :key="index" class="gj-list">
      <van-radio-group v-model="radioValue">
        <van-radio icon-size="18px" shape="square" label-disabled :name="item.flowId" @click="checkChange(item)">
          <mzjfListItem :item="item" />
        </van-radio>
      </van-radio-group>
    </div>
  </div>
</template>
<script>
import mzjfListItem from './list-item'
export default {
  name: 'MenZhenJiaoFeiList',
  filters: {
    status: val => {
      switch (val) {
        case 0:
          return '待缴费'
        case 1:
          return '缴费成功'
        case 2:
          return '已作废'
        default:
          return ''
      }
    }
  },
  components: {
    mzjfListItem
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      radioValue: ''
    }
  },
  activated() {
    this.radioValue = ''
  },
  methods: {
    checkChange(obj) {
      this.$emit('checkChange', obj)
      console.log(obj)
    },
    toVoucher(id) {
      this.$Apis.getEinvoiceDetailsById({ Id: id }).then(res => {
        if (res.code === 200) {
          window.location.href = res.data.dzpjurl
        } else {
          this.$toast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-checkbox__label {
  flex: 1 !important;
}

/deep/ .van-radio__label{
  width: 100%;
}
</style>
